
<div class="search-div">
  Details and Results for Experiment # {{ currentExperimentId }}

  <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
    <mat-label>Search</mat-label>
    <input
      matInput
      type="text"
      placeholder="Search"
      data-testid="lp-results-search-input"
      autocomplete="off"
      [(ngModel)]="searchKey"
      (ngModelChange)="onSearchChanged()" />
    <button
      *ngIf="searchKey"
      matSuffix
      mat-icon-button
      data-testid="lp-results-search-clear-button"
      aria-label="Clear search"
      (click)="onSearchClear()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-icon matSuffix *ngIf="!searchKey">search</mat-icon>
  </mat-form-field>

  <mat-slide-toggle [(ngModel)]="hideEmptyResults" color="primary" data-testid="lp-results-hideempty-toggle" (change)="hideResultsChanged()">
    Hide Empty Results
  </mat-slide-toggle>

  <button mat-raised-button data-testid="lp-results-export-menu-button" [matMenuTriggerFor]="menuExportTargets" [disabled]="isLoading">Export</button>
  <mat-menu #menuExportTargets="matMenu">
    <button
      mat-menu-item
      data-testid="lp-results-export-allrecords-button"
      (click)="downloadCsvFile(false)"
      matTooltip="Click to download data as CSV"
      *ngIf="currentExperimentId != 0">
      All records
    </button>
    <button
      mat-menu-item
      data-testid="lp-results-export-invalidanalytes-button"
      (click)="downloadCsvFile(true)"
      matTooltip="Click to download invalid analytes as CSV"
      *ngIf="currentExperimentId != 0">
      Invalid Analytes
    </button>
  </mat-menu>

  <mat-form-field name="assay-layout" class="assay-layout-form-field" appearance="outline"
    subscriptSizing="dynamic" *ngIf="currentExperimentId != 0">
    <mat-label for="assay-layout">Assay Layout</mat-label>
    <mat-select
      data-testid="lp-results-assaylayout-select"
      [(ngModel)]="selectedAssayIdRevision"
      [compareWith]="compareAssayLayouts"
      (selectionChange)="initializeColumns()"
      matBadge="{{ assayIdRevisionGroups.length }}"
      [matBadgeHidden]="assayIdRevisionGroups.length <= 1">
      <mat-option *ngFor="let assayIdRevision of assayIdRevisionGroups" [value]="assayIdRevision.value">
        {{ assayIdRevision.viewValue }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="column-selector" subscriptSizing="dynamic"
    *ngIf="tableColumns.length && !isLoading">
    <mat-label>Choose Columns</mat-label>
    <mat-select
      multiple
      data-testid="lp-results-columns-select"
      [(ngModel)]="columnSelectionDraft"
      [compareWith]="compareColumnsByField"
      (openedChange)="$event ? onColumnSelectionShow() : onColumnSelectionHide()">
      <mat-select-trigger>
        {{ columnSelectionDraft.length || 0 }} columns selected
      </mat-select-trigger>
      <mat-option *ngFor="let option of columnVisibilityOptions; trackBy: trackColumnByField" [value]="option">
        {{ option.header }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <button mat-raised-button data-testid="lp-results-reset-button" (click)="resetTable()" matTooltip="Click to reset table to default state">
    Reset Table
  </button>

  <button matSuffix mat-icon-button class="btn-refresh" data-testid="lp-results-refresh-button" (click)="refreshResults()">
    <mat-icon>refresh</mat-icon>
  </button>

  <div class="labpartner-experiment-link">
    <a routerLink="/labpartner" data-testid="lp-results-viewlabpartner-link" [queryParams]="{ experimentid: currentExperimentId }">View LabPartner Data</a>
  </div>

  <ng-container *ngIf="currentExperiment">
    <app-results-links [experiment]="currentExperiment" [showSavannaResultsLink]="false"></app-results-links>    
  </ng-container>
</div>
<div class="results-table-shell mat-elevation-z1" *ngIf="currentExperimentId != 0" [class.column-resizing]="isColumnResizeActive">
  <div class="results-table-scroll">
    <table
      #resultsTable
      mat-table
      [dataSource]="renderedTableData"
      [fixedLayout]="true"
      cdkDropList
      cdkDropListOrientation="horizontal"
      cdkDropListLockAxis="x"
      [cdkDropListData]="displayedColumns"
      [cdkDropListSortPredicate]="canReorderColumnAtIndex"
      (cdkDropListDropped)="onColumnReorder($event)"
      class="results-table savanna-results-duplicates-tbl"
      data-testid="lp-results-table"
      matSort
      [matSortActive]="sortState.active"
      [matSortDirection]="sortState.direction"
      (matSortChange)="customSort($event)">
      <ng-container
        *ngFor="let col of displayedColumns; trackBy: trackColumnByField"
        [matColumnDef]="col.field"
        [sticky]="isStickyColumn(col)">
        <th
          mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="col.field"
          cdkDrag
          [cdkDragDisabled]="isColumnResizeActive"
          cdkDragLockAxis="x"
          (cdkDragStarted)="onColumnDragStarted()"
          (cdkDragEnded)="onColumnDragEnded()"
          [cdkDragData]="col"
          [style.width.px]="getColumnWidth(col)"
          [style.minWidth.px]="getColumnWidth(col)"
          [style.maxWidth.px]="getColumnWidth(col)"
          [class.freezable-column]="isFrozenColumn(col)"
          [class.header-cell-active]="isColumnSorted(col)"
          [class.assay-column]="col.parentField === 'assay'">
          <div class="header-cell-content">
            <div class="header-cell-label">
              <ng-container *ngIf="col.parentField !== 'assay'; else assayColumnHeader">
                {{ col.header }}
              </ng-container>
              <ng-template #assayColumnHeader>
                <div>{{ col.header }}</div>
                <div class="assay-column-counts" *ngIf="columnCounts[col.header]">
                  {{ columnCounts[col.header][RESULT_POSITIVE] }} / {{ columnCounts[col.header][RESULT_NEGATIVE] }} /
                  {{ columnCounts[col.header][RESULT_INVALID] }} / {{ columnCounts[col.header][RESULT_UNEVALUABLE] }}
                </div>
              </ng-template>
            </div>
            <span class="column-sort-icon" [class.active]="isColumnSorted(col)" aria-hidden="true">
              <i [class]="getColumnSortIconClass(col)"></i>
            </span>
          </div>
          <span
            class="column-resize-handle"
            [class.active]="resizingColumnField === col.field"
            (pointerdown)="startColumnResize($event, col)"></span>
        </th>

        <td
          mat-cell
          *matCellDef="let rowData"
          [style.width.px]="getColumnWidth(col)"
          [style.minWidth.px]="getColumnWidth(col)"
          [style.maxWidth.px]="getColumnWidth(col)"
          [class.freezable-column]="isFrozenColumn(col)"
          [class.assay-column]="col.parentField === 'assay'">
          <ng-container *ngIf="col.parentField !== 'assay'">
            <ng-container *ngIf="col.field === 'barcodeID'; else tmpInstrumentError">
              <ng-container *ngIf="currentExperiment?.status != VerbedExperimentStatus.IsDetailsGenerated">
                {{ rowData.detail.barcodeID }}
              </ng-container>
              <mat-icon
                *ngIf="rowData.hasDuplicateResults"
                class="duplicate-warning"
                matTooltip="Duplicate results found (showing most recent). Download CSV to see details of other results"
                matBadge="{{ rowData.otherResults.length + 1 }}"
                [attr.data-testid]="'lp-results-duplicate-icon-' + rowData.detail.detailId">
                warning
              </mat-icon>
              <mat-icon
                *ngIf="rowData.result?.isAssayIdAndRevisionOutlier"
                class="assay-revision-mismatch"
                matTooltip="Assay Id ({{ rowData.result?.assayId }})
                and Revision ({{ rowData.result?.assayRevision }}) do not match the majority of the other results."
                [attr.data-testid]="'lp-results-mismatch-icon-' + rowData.detail.detailId">
                report
              </mat-icon>
            </ng-container>
            <ng-template #tmpInstrumentError>
              <ng-container *ngIf="col.field === 'instrumentError'; else tmpUnevalData">
                <mat-checkbox
                  class="instrument-error-checkbox"
                  [disabled]="
                    (currentExperiment | statusIsNot : ['ReadyToTest']) ||
                    (rowData.detail.unevaluable && !rowData.detail.instrumentError)
                  "
                  [checked]="rowData.detail.instrumentError"
                  (change)="$event ? toggleDetailInstrumentError(rowData, $event) : null"
                  [attr.data-testid]="'lp-results-instrumenterror-checkbox-' + rowData.detail.detailId">
                </mat-checkbox>
              </ng-container>
            </ng-template>
            <ng-template #tmpUnevalData>
              <ng-container *ngIf="col.field === 'unevaluable'; else tmpNotes">
                <div class="not-eval-container">
                  <mat-checkbox
                    class="unevaluable-checkbox"
                    data-testid="lp-results-unevaluable-checkbox"
                    [disabled]="
                      (currentExperiment | statusIsNot : ['ReadyToTest']) ||
                      rowData.detail.sampleIgnore ||
                      rowData.detail.conditionIgnore ||
                      (rowData.detail.instrumentError && !rowData.detail.unevaluable)
                    "
                    [checked]="rowData.detail.unevaluable || rowData.detail.sampleIgnore || rowData.detail.conditionIgnore"
                    (change)="$event ? toggleDetailUnevaluable(rowData, $event) : null"
                    [attr.data-testid]="'lp-results-unevaluable-checkbox-' + rowData.detail.detailId">
                  </mat-checkbox>
                  <div [style.visibility]="rowData.detail.sampleIgnore ? 'visible' : 'hidden'">&nbsp;S</div>
                  <div [style.visibility]="rowData.detail.conditionIgnore ? 'visible' : 'hidden'">&nbsp;C</div>
                  <div [style.visibility]="rowData.detail.unevaluable ? 'visible' : 'hidden'">&nbsp;D</div>
                </div>
              </ng-container>
            </ng-template>
            <ng-template #tmpNotes>
              <ng-container *ngIf="col.field === 'notes'; else tmplNotBarcodeId">
                <app-note-display
                  [experimentId]="currentExperimentId"
                  [noteCount]="detailsNotesCountMap && detailsNotesCountMap[rowData.detail.detailId]"
                  [hasLiveNote]="detailsLiveNotesCountMap && detailsLiveNotesCountMap[rowData.detail.detailId] > 0"
                  [objectID]="rowData.detail.detailId"
                  [objectName]="'Detail'"
                  [experimentDetail]="rowData.detail">
                </app-note-display>
              </ng-container>
            </ng-template>
            <ng-template #tmplNotBarcodeId>
              {{ rowData[col.parentField] && rowData[col.parentField][col.field] }}
            </ng-template>
          </ng-container>

          <ng-container *ngIf="col.parentField === 'assay'">
            <ng-container
              *ngIf="
                rowData.result != null &&
                rowData.result?.assayId == selectedAssayIdRevision?.assayId &&
                rowData.result?.assayRevision == selectedAssayIdRevision?.assayRevision &&
                rowData.result.shortNameTargetMap &&
                rowData.result.shortNameTargetMap[col.field]
              ">
              <ng-container *ngIf="validateCurrentLayout(rowData.result)">
                <ng-container [ngSwitch]="rowData.result.shortNameTargetMap[col.field].qualitativeResult">
                  <ng-container *ngSwitchCase="'Positive'" [ngTemplateOutlet]="tmplPositiveResult"></ng-container>
                  <ng-container *ngSwitchCase="'Negative'" [ngTemplateOutlet]="tmplNegativeResult"></ng-container>
                  <ng-container *ngSwitchCase="'Invalid'" [ngTemplateOutlet]="tmplInvalidResult"></ng-container>
                </ng-container>
                <mat-icon
                  *ngIf="rowData.result.shortNameTargetMap[col.field].isUnevaluable"
                  class="unevaluable-warning unevaluable-badge"
                  matTooltip="Not Evaluable">
                  warning
                </mat-icon>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="rowData.result == null && (rowData.detail.instrumentError || (rowData.targetError && columnHasUnevaluable(rowData, col.field)))">
              <mat-icon class="unevaluable-warning" matTooltip="Not Evaluable">
                warning
              </mat-icon>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumnFields; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnFields"></tr>
    </table>
  </div>

  <div class="results-table-footer">
    <div class="results-current-page-report">{{ currentPageReport }}</div>
    <mat-paginator
      data-testid="lp-results-paginator"
      [length]="tableData.length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons
      (page)="onPageChange($event)"></mat-paginator>
  </div>

  <div class="results-table-loading" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</div>

<ng-template #tmplPositiveResult>
  <img class="result-images" src="/assets/images/result-positive.png" />
</ng-template>

<ng-template #tmplNegativeResult>
  <img class="result-images" src="/assets/images/result-negative.png" />
</ng-template>

<ng-template #tmplInvalidResult>
  <img class="result-images" src="/assets/images/result-invalid.png" />
</ng-template>


<div [style.visibility]="'hidden'">
  <ng-container [ngTemplateOutlet]="tmplPositiveResult"></ng-container>
  <ng-container [ngTemplateOutlet]="tmplNegativeResult"></ng-container>
  <ng-container [ngTemplateOutlet]="tmplInvalidResult"></ng-container>
</div>

<div class="noExperimentWarning" *ngIf="currentExperimentId == 0">
  Please choose an experiment from the Experiments tab.
</div>
